import script from "./BasicComp.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicComp.vue?vue&type=script&setup=true&lang=js"

import "./BasicComp.vue?vue&type=style&index=0&id=4ead601e&lang=css"

const __exports__ = script;

export default __exports__